import RevealOnScroll from './RevealOnScroll';

export default function Contact({ info }) {
  const address = info?.address || 'Nişantaşı, Valikonağı Cad.\nNo: 12, Şişli / İstanbul';
  const phone = info?.phone || '+90 (500) 000 00 00';
  const email = info?.email || 'info@nisantasikuafor.com';
  const hours = info?.working_hours || 'Pzt - Cmt: 09:00 - 20:00';
  const offDay = info?.off_day || 'Pazar: Kapalı';
  const mapsEmbed = info?.maps_embed || '';

  const phoneHref = `tel:${phone.replace(/[^+\d]/g, '')}`;

  return (
    <section className="section contact-section" id="contact">
      <RevealOnScroll>
        <div className="section-header">
          <span className="section-tag">Bize Ulaşın</span>
          <h2 className="section-title">İLETİŞİM</h2>
          <div className="section-ornament">
            <div className="line" />
            <div className="dot" />
            <div className="line" />
          </div>
        </div>
      </RevealOnScroll>
      <RevealOnScroll>
        <div className="contact-grid">
          <div className="contact-card">
            <div className="contact-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </div>
            <h4 className="contact-label">Adres</h4>
            <p className="contact-value">{address.split('\n').map((line, i) => (
              <span key={i}>{line}{i < address.split('\n').length - 1 && <br />}</span>
            ))}</p>
          </div>

          <div className="contact-card">
            <div className="contact-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
              </svg>
            </div>
            <h4 className="contact-label">Telefon</h4>
            <a href={phoneHref} className="contact-value contact-link">{phone}</a>
          </div>

          <div className="contact-card">
            <div className="contact-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <rect x="2" y="4" width="20" height="16" rx="2" />
                <path d="M22 4l-10 8L2 4" />
              </svg>
            </div>
            <h4 className="contact-label">E-posta</h4>
            <a href={`mailto:${email}`} className="contact-value contact-link">{email}</a>
          </div>

          <div className="contact-card">
            <div className="contact-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
            </div>
            <h4 className="contact-label">Çalışma Saatleri</h4>
            <p className="contact-value">{hours}<br />{offDay}</p>
          </div>
        </div>
      </RevealOnScroll>

      {mapsEmbed && (
        <RevealOnScroll>
          <div className="contact-map">
            <div className="contact-map-border">
              <iframe
                title="Konum"
                src={mapsEmbed}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </RevealOnScroll>
      )}
    </section>
  );
}
